const people = [
  {
    id: 1,
    image:
      'https://firebasestorage.googleapis.com/v0/b/portfolio2022-yang.appspot.com/o/austin-wade-o1lNGAVrS4o-unsplash.jpg?alt=media&token=75a04ac9-f80d-4a40-b98f-b07b28861946',
    name: 'Julian Buchanan',
    title: 'manager',
    quote:
      'They took the time to understand who we are as a company and gave us a few amazing marketing plans to choose from. We wholeheartedly recommend Silver Tongue to everyone we know.',
  },
  {
    id: 2,
    image:
      'https://firebasestorage.googleapis.com/v0/b/portfolio2022-yang.appspot.com/o/courtney-cook-le7D9QFiPr8-unsplash.jpg?alt=media&token=16463edb-9083-46a2-a4cd-520531da87d0',
    name: 'Harry Stamper',
    title: 'Instructor',
    quote:
      'It only serves to show what sort of person a man must be who cannot even get testimonials. No, no; if a man brings references, it proves nothing; but if he cannot, it proves a great deal.',
  },
  {
    id: 3,
    image:
      'https://firebasestorage.googleapis.com/v0/b/portfolio2022-yang.appspot.com/o/vicky-hladynets-C8Ta0gwPbQg-unsplash.jpg?alt=media&token=f2024552-f756-48ec-9cde-33813646202e',
    name: 'Alex White',
    title: 'Project Manager',
    quote:
      'I could not have asked for a better testimonial than Bob Dylan parting with his own cash for a pair of my shoes.',
  },
  {
    id: 4,
    image:
      'https://firebasestorage.googleapis.com/v0/b/portfolio2022-yang.appspot.com/o/petr-sevcovic-auCjz0gucr0-unsplash.jpg?alt=media&token=20bf643e-98f7-40d3-8656-13fa59dcaf91',
    name: 'Christian Bale',
    title: 'Vice President',
    quote:
      'I am going to be wearing the Stryker hat because I am a walking testimonial to the fact that you can get your knee replaced and still play at a really high level and get your life back.',
  },
];

export default people;
